export default "__VITE_ASSET__BA8T2p$C__"